module.exports = __webpack_public_path__ + "static/media/22.52641d54.mp3";